import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/site/legal-page";
import { langPageMeta } from "@/content/site";
import { i18n } from "@/i18n";

const PATH = "/cookiebeleid";

export const Route = createFileRoute("/$lang/cookiebeleid")({
  staticData: { sitemap: true },
  head: ({ params }) => {
    const title = i18n.t("legal:cookies.title");
    const description = i18n.t("legal:cookies.description");
    const lang = langPageMeta(params.lang, PATH);
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary" },
        ...lang.meta,
      ],
      links: lang.links,
    };
  },
  component: () => <LegalPage doc="cookies" />,
});
